export function layerListReducer(state: LayerListState, action: LayerListAction) {
    switch (action.type) {
        case "TOGGLE_EXPANDED":
            return { ...state, expanded: !state.expanded };
        case "SET_AVAILABLE_LAYERS":
            return { ...state, availableLayerIds: action.layerIds, displayedLayers: action.layerIds };
        case "SET_HIDDEN_LAYERS":
            return { ...state, hiddenLayers: new Set(action.layerIds) };
        case "SET_DISPLAYED_LAYERS":
            return { ...state, displayedLayers: action.layerIds };
        case "SET_SEARCH_VALUE": {
            const searchValue = action.value;
            const displayedLayers = !searchValue ? state.availableLayerIds : state.availableLayerIds.filter((layerId) => layerId.toLowerCase().includes(searchValue.toLowerCase()));

            return {
                ...state,
                searchValue,
                displayedLayers,
            };
        }
        default:
            throw Error(`Unknown action: ${action.type}`);
    }
}

// State interface
export interface LayerListState {
    expanded: boolean;
    availableLayerIds: string[];
    hiddenLayers: Set<string>;
    searchValue: string;
    displayedLayers: string[];
}

// Initial state
export const initialLayerListState: LayerListState = {
    expanded: false,
    availableLayerIds: [],
    hiddenLayers: new Set<string>(),
    searchValue: "",
    displayedLayers: [],
};

// Action types
export type LayerListAction =
    | { type: "TOGGLE_EXPANDED" }
    | { type: "SET_AVAILABLE_LAYERS"; layerIds: string[] }
    | { type: "SET_HIDDEN_LAYERS"; layerIds: string[] }
    | { type: "SET_DISPLAYED_LAYERS"; layerIds: string[] }
    | { type: "TOGGLE_LAYER"; layerId: string; isChecked: boolean }
    | { type: "SET_SEARCH_VALUE"; value: string };
